import http from '../../http'
export default {
  add: (params) => {
    return http.post('activityservice/screenmanage/insert', params)
  },
  update: (params) => {
    return http.post('activityservice/screenmanage/update', params)
  },
  del: (params) => {
    return http.post('activityservice/screenmanage/delete', params)
  },
  list: (params) => {
    return http.post('activityservice/screenmanage/list', params)
  },

  setting: {
    //基本设置
    basic: {
      get: (params) => {
        return http.post('activityservice/screenbasicsetup/query', params)
      },
      update: (params) => {
        return http.post('activityservice/screenbasicsetup/update', params)
      }
    },
    //模板设置
    template: {
      list: (params) => {
        return http.post('activityservice/templatesetup/list', params)
      },
      inset: (params) => {
        return http.post('activityservice/templatesetup/insert', params)
      },
      update: (params) => {
        return http.post('activityservice/templatesetup/update', params)
      },
      delete: (params) => {
        return http.post('activityservice/templatesetup/delete', params)
      }
    },
    //弹幕设置
    barrage: {
      list: (params) => {
        return http.post('activityservice/bulletscreen/list', params)
      },
      insert: (params) => {
        return http.post('activityservice/bulletscreen/insert', params)
      },
      update: (params) => {
        return http.post('activityservice/bulletscreen/update', params)
      },
      delete: (params) => {
        return http.post('activityservice/bulletscreen/delete', params)
      }
    }
  },

  //抽奖模块
  prize: {
    prizeSavefile: (data) => {
      return http.post('mprizeservice/prize/savefile', data)
    },
    add: (params) => {
      return http.post('mprizeservice/prize/save', params)
    },
    update: (params) => {
      return http.post('mprizeservice/prize/update', params)
    },
    del: (params) => {
      return http.post('mprizeservice/prize/delete', params)
    },
    get: (params) => {
      return http.post('mprizeservice/prize/findone', params)
    },
    list: (params) => {
      return http.post('mprizeservice/prize/list', params)
    },
    person: (params) => {
      return http.post('mprizeservice/winninglist/page', params)
    },
    delPerson: (params) => {
      return http.post('mprizeservice/winninglist/deleteone', params)
    },
    exportPerson: (params) => {
      return http.post('mprizeservice/winninglist/page/export', params)
    },
    winningListSavewinners: (data) => {
      return http.post('mprizeservice/winninglist/savewinners', data)
    }, //保存中奖人员名单
    winningListDelete: (data) => {
      return http.post('mprizeservice/winninglist/delete', data)
    }, //删除奖项下的中奖人员名单
  },

  //用户模块
  person: {
    add: (params) => {
      return http.post('activityservice/rostersetup/insert', params)
    },
    update: (params) => {
      return http.post('activityservice/rostersetup/update', params)
    },
    updateAll: (params) => {
      return http.post('activityservice/rostersetup/batchupdate', params)
    },
    del: (params) => {
      return http.post('activityservice/rostersetup/delete', params)
    },
    delAll: (params) => {
      return http.post('activityservice/rostersetup/batchdelete', params)
    },
    list: (params) => {
      return http.post('activityservice/rostersetup/list', params)
    },
    importActivePerson:  (params) => {
      return http.get('activityservice/rostersetup/synchron', params)
    }
  },

  //消息模块
  message: {
    page: (params) => {
      return http.post('message/message/page', params)
    }, //获取消息
    delete: (params) => {
      return http.post('message/message/delete', params)
    }, //删除消息
    chatset: (params) => {
      return http.post('message/messageset/chatset', params)
    }, //弹幕设置”是否启用聊天设置”+弹幕设置”是否开启评论审核
    onthewallset: (params) => {
      return http.post('message/message/update', params)
    }, //更改消息为上墙和未上墙,0代表上1代表不上
    auditset: (params) => {
      return http.post('message/message/audit', params)
    }, //更改改消息为是否审核状态,0代表未审核,1代表已审核
    export: (params) => {
      return http.post('message/message/export', params)
    }, //导出消息数据
    getset: (params) => {
      return http.post('message/messageset/get', params)
    },
  }

}
